(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-collection-header';

  // Build the target URL for a sort option: keep existing query params (active
  // filters), set/replace sort_by, and reset pagination.
  function buildSortUrl(value) {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', value);
    params.delete('page');
    return window.location.pathname + '?' + params.toString();
  }

  function initSortControl(wrap) {
    var toggle = wrap.querySelector('[data-collection-sort-toggle]');
    var menu = wrap.querySelector('.oddit-section-collection-header__sort-menu');
    if (!toggle || !menu) return;

    function close() {
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    function open() {
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (wrap.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    menu.querySelectorAll('[data-sort-value]').forEach(function (option) {
      option.addEventListener('click', function () {
        var value = option.getAttribute('data-sort-value');
        if (value) {
          window.location.href = buildSortUrl(value);
        }
      });
    });

    // Close on outside click / Escape.
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function initSection(section) {
    if (!section || section.__odditHeaderInit) return;
    section.__odditHeaderInit = true;

    section
      .querySelectorAll('.oddit-section-collection-header__sort-wrap')
      .forEach(initSortControl);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll(SECTION_SELECTOR)
      : [];
    sections.forEach(initSection);
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
